import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import PersonaCreatorHeader from './PersonaCreatorHeader';
import PersonaCreatorSegmentsHeader from './PersonaCreatorSegmentsHeader';
import { NO_VALID_SEGMENT_DATA_MSG } from '../../../messages/messages';
import PercentageFilterSlider from '../PercentageFilterSlider';
import { validateSegmentScreenDisplay } from '../../../util/Insight360Utils';

const displayWarningMessage = () => NO_VALID_SEGMENT_DATA_MSG;

const PersonaCreator = ({
  removePersonaCreator,
  getPersonaCreatorProfilesData,
  savePersonaCreatorDefLabel,
  segmentsScreen,
  personaCreator,
  applyVpctFilter,
  trackerFn,
}) => (<div
  className="row expanded header-margin personaCreatorHeader"
  id="creatorHeader"
>
  <div className="personaCreatorHeader">
    <PersonaCreatorHeader
      removePersonaCreator={removePersonaCreator}
      getPersonaCreatorProfilesData={getPersonaCreatorProfilesData}
      savePersonaCreatorDefLabel={savePersonaCreatorDefLabel}
      trackerFn={trackerFn}
    />
  </div>
  {segmentsScreen === false &&
    validateSegmentScreenDisplay(personaCreator) && (<div className="pdfpcSegmentHeader">
      <PersonaCreatorSegmentsHeader />
    </div>
    )}
  {segmentsScreen === false &&
    personaCreator.segments.segments !== undefined &&
    personaCreator.segments.segments.length >= 0 &&
    !validateSegmentScreenDisplay(personaCreator) && (<span
      style={{ color: 'darkred', float: 'left', fontWeight: 'bold' }}
    >
      {' '}
      {displayWarningMessage()}
    </span>
    )}

  {/* {personaCreator.header !== undefined &&
    validateSegmentScreenDisplay(personaCreator) && (<PercentageFilterSlider
      value={personaCreator.inight360VerticalPercent}
      applyVpctFilter={applyVpctFilter}
    />
    )} */}
</div>
  );

PersonaCreator.propTypes = {
  removePersonaCreator: PropTypes.func,
  getPersonaCreatorProfilesData: PropTypes.func,
  savePersonaCreatorDefLabel: PropTypes.func,
  segmentsScreen: PropTypes.bool,
  personaCreator: PropTypes.shape({}),
  applyVpctFilter: PropTypes.func,
  trackerFn: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    personaCreator: state.insight360.personaCreator,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
)(PersonaCreator);
